import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLogin } from '../hooks/useLogin';
import { ApiError } from '@/lib/api-client';
import { EditorialField, EditorialSubmit, EditorialAlert, editorialInputStyle, } from './EditorialField';
const ACCENT_RGB = '56,182,239';
function getErrorMessage(err) {
    // Too many attempts hit the rate limiter (429) before reaching the handler.
    if (err.status === 429) {
        return 'Demasiados intentos. Espera un minuto e inténtalo de nuevo.';
    }
    switch (err.code) {
        case 'AUTH_INVALID_CREDENTIALS':
            return 'Email o contraseña incorrectos.';
        // Lockout + disabled carry a specific, dynamic server message (e.g. minutes
        // left / "contacta con la academia") — show it verbatim when present.
        case 'AUTH_ACCOUNT_LOCKED':
            return err.message || 'Cuenta bloqueada temporalmente por intentos fallidos.';
        case 'AUTH_ACCOUNT_DISABLED':
            return err.message || 'Tu cuenta está desactivada. Contacta con la academia.';
        default:
            return err.message || 'No se pudo iniciar sesión. Inténtalo de nuevo.';
    }
}
export function LoginForm() {
    const [serverError, setServerError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const login = useLogin();
    const { register, handleSubmit, formState: { errors }, } = useForm();
    function onSubmit(values) {
        setServerError(null);
        login.mutate(values, {
            onError: (err) => {
                setServerError(err instanceof ApiError
                    ? getErrorMessage(err)
                    : 'No se pudo conectar. Comprueba tu conexión e inténtalo de nuevo.');
            },
        });
    }
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "flex flex-col gap-8", noValidate: true, children: [_jsx(EditorialField, { label: "Email", index: "01", htmlFor: "login-email", error: errors.email?.message, children: _jsx("input", { id: "login-email", type: "email", autoComplete: "email", placeholder: "tu@email.com", style: editorialInputStyle, ...register('email', {
                        required: 'El email es obligatorio',
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: 'Email no válido',
                        },
                    }) }) }), _jsx(EditorialField, { label: "Contrase\u00F1a", index: "02", htmlFor: "login-password", error: errors.password?.message, right: _jsx("button", { type: "button", onClick: () => setShowPassword((v) => !v), className: "font-mono font-bold uppercase transition-opacity hover:opacity-70", style: {
                        fontSize: '10px',
                        letterSpacing: '0.18em',
                        color: `rgba(${ACCENT_RGB},0.85)`,
                        padding: 0,
                    }, tabIndex: -1, children: showPassword ? 'Ocultar' : 'Mostrar' }), children: _jsx("input", { id: "login-password", type: showPassword ? 'text' : 'password', autoComplete: "current-password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", style: editorialInputStyle, ...register('password', { required: 'La contraseña es obligatoria' }) }) }), serverError && _jsx(EditorialAlert, { message: serverError }), _jsx(EditorialSubmit, { loading: login.isPending, label: "Acceder", loadingLabel: "Entrando\u2026" })] }));
}
//# sourceMappingURL=LoginForm.js.map